import type { CityConfig } from "../city-template/types";

export const lovelandConfig: CityConfig = {
  city: "Loveland",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "loveland",
  route: "/loveland",
  title: "Emergency Passport Loveland, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Loveland, Colorado — as fast as 24 hours. Same-day courier processing for Loveland, Fort Collins, Windsor, Berthoud, and all northern Colorado travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Loveland, CO",
  heroSubtitle: "Sculpture festival in Europe and your passport just expired? Family reunion in Germany next week? We help Loveland residents — from Centerra professionals to downtown artists to Mariana Butte families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Loveland%20Colorado%20scenic%20view%20of%20the%20Benson%20Sculpture%20Garden%20with%20bronze%20sculptures%20set%20among%20landscaped%20flower%20gardens%20and%20walking%20paths%2C%20the%20Rocky%20Mountain%20foothills%20in%20the%20background%20with%20Longs%20Peak%20visible%20on%20the%20horizon%2C%20the%20Big%20Thompson%20River%20flowing%20through%20green%20parkland%2C%20the%20vibrant%20downtown%20Loveland%20arts%20district%20with%20galleries%20and%20public%20art%2C%20bright%20Colorado%20sunshine%20with%20crisp%20mountain%20air%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20horizontal%20composition%20with%20natural%20color%20palette&width=1800&height=700&seq=loveland-hero-001&orientation=landscape",
  heroImageAlt: "Loveland Colorado Benson Sculpture Garden with Rocky Mountain foothills and Longs Peak backdrop",
  geoPosition: "40.3978;-105.0749",
  geoPlacename: "Loveland, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 60 miles south via I-25 — about 1 hour",
  },
  nearbyCitiesZips: [
    { name: "Loveland", zips: "80534, 80537, 80538, 80539" },
    { name: "Fort Collins", zips: "80521, 80524, 80525, 80526, 80528" },
    { name: "Windsor", zips: "80550, 80551" },
    { name: "Berthoud", zips: "80513" },
    { name: "Johnstown", zips: "80534" },
    { name: "Timnath", zips: "80547" },
    { name: "Severance", zips: "80546" },
    { name: "Wellington", zips: "80549" },
    { name: "Estes Park", zips: "80511, 80517" },
    { name: "Greeley", zips: "80631, 80632, 80634, 80639" },
    { name: "Mead", zips: "80542" },
    { name: "Longmont", zips: "80501, 80503, 80504" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Loveland international travel — business and family" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — no need to drive 1 hour south to the Colorado Passport Agency" },
    { icon: "ri-flight-takeoff-line", title: "FNL & DEN Airport Access", desc: "Local FNL airport and 50-min access to DEN — courier coordination for last-minute flights" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Loveland, Fort Collins, or Centerra" },
  ],
  internalLinks: [
    { name: "Expedited passport in Fort Collins, CO", route: "/fort-collins" },
    { name: "Emergency passport help in Denver, CO", route: "/denver" },
    { name: "Fast passport renewal in northern Colorado", route: "/loveland" },
    { name: "Urgent passport services for Windsor and Berthoud", route: "/loveland" },
    { name: "Colorado passport services overview", route: "/colorado" },
    { name: "Passport courier services in Larimer County", route: "/loveland" },
    { name: "Fast Passport Center — Cheyenne, WY office", route: "/cheyenne" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Loveland remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Loveland's location in northern Larimer County — 60 miles from Denver — makes our courier service especially valuable. Skip the 1-hour drive down I-25 and let us handle everything. The closest Fast Passport Center physical office is located at 2020 Carey Ave, Cheyenne, WY 82001 — about 1 hour north via I-25 and US-287.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Larimer County including Loveland, Fort Collins, Berthoud, Windsor, and the surrounding communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Loveland and northern Larimer County. From downtown Loveland's arts district to the Centerra shopping area, from Mariana Butte to the Big Thompson Canyon communities — we serve every neighborhood in Loveland and the surrounding region.",
  nearbyCitiesIntro: "We serve Loveland and all nearby northern Colorado communities including Fort Collins, Windsor, Berthoud, Johnstown, Timnath, Severance, and Wellington. We also serve Estes Park, Greeley, Mead, and Longmont.",
  howItWorksIntro: "Most Loveland travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to drive 60 miles south on I-25 to the Colorado Passport Agency.",
  mistakesIntro: "Loveland is known for its arts community, outdoor recreation, and family-friendly atmosphere. Here are the most common passport mistakes we see from Loveland-area travelers.",
  testimonialsIntro: "Loveland travelers — from Centerra professionals to downtown artists to Mariana Butte residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Loveland, CO? Here are the most common ones we hear from northern Colorado travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (CDPHE)", url: "https://cdphe.colorado.gov/vital-records", desc: "Colorado Department of Public Health & Environment for vital records statewide" },
    { label: "Marriage Licenses (Larimer County Clerk)", url: "https://www.larimer.gov/", desc: "Larimer County Clerk & Recorder for Loveland area" },
    { label: "Divorce Decrees (Larimer County District Court)", url: "https://www.courts.state.co.us/Courts/District/Index.cfm?District_ID=8", desc: "Larimer County District Court for divorce decree records" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Colorado vital records online via VitalChek" },
  ],
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No I-25 drive to Denver required — ship from Loveland", "Perfect for arts festival travel and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (1 hour each way)", "Limited appointments — book 3 weeks ahead"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Loveland travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service available without the 1-hour drive to Denver.",
      bullets: ["24–48 hour turnaround available", "FNL and DEN departure support", "Arts festival and family travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Loveland adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Loveland address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Loveland residents — including young adults, new citizens, and children applying for their first passport.",
      bullets: ["Acceptance facility scheduling in Loveland or Fort Collins", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Loveland residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Loveland and northern Colorado families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Loveland and Larimer County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Loveland CO", description: "Urgent passport processing for Loveland Colorado travelers with immediate departure needs from DEN or FNL." },
    { name: "Expedited Passport Renewal Loveland CO", description: "Fast passport renewal for Loveland Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Loveland CO", description: "New passport application services for Loveland Colorado residents applying for their first passport." },
    { name: "Child Passport Loveland CO", description: "Minor passport services for Loveland Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Nancy P.",
      location: "Loveland, CO — Mariana Butte",
      rating: 5,
      text: "Sculpture symposium in Italy and realized my passport had expired 2 weeks before flying out. Fast Passport Center got it done in 3 days. The courier service is perfect for northern Colorado.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Greg B.",
      location: "Loveland, CO — Centerra",
      rating: 5,
      text: "Family trip to Ireland for a wedding. Three passports — one renewal and two first-time for our kids. All done in 5 days without a single drive to Denver. Amazing service.",
      service: "Family Passport Bundle",
    },
    {
      name: "Linda K.",
      location: "Fort Collins, CO",
      rating: 5,
      text: "Business conference in Amsterdam with 6 days notice. Fast Passport Center walked me through everything and had my passport in 2 days. No I-25 traffic frustration.",
      service: "Emergency Passport",
    },
    {
      name: "Roger D.",
      location: "Berthoud, CO",
      rating: 5,
      text: "Lost my passport during a camping trip in Rocky Mountain National Park with a trip to Canada in 4 days. They got me a replacement in 48 hours. Absolutely saved our anniversary trip.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "lov-1",
      name: "Loveland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "446 E 29th St",
      city: "Loveland",
      state: "CO",
      zip: "80538",
      phone: "(970) 669-9851",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Central Loveland, near US-287 and 29th Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Loveland acceptance facility. Good parking. Appointments recommended — book 2–3 weeks ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "lov-2",
      name: "Fort Collins Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 E Boardwalk Dr",
      city: "Fort Collins",
      state: "CO",
      zip: "80525",
      phone: "(970) 226-1034",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Fort Collins, approximately 12 miles north of Loveland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest acceptance facility in northern Colorado. Extended hours. Serves all of Larimer County.",
      icon: "ri-mail-line",
    },
    {
      id: "lov-3",
      name: "Windsor Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "402 6th St",
      city: "Windsor",
      state: "CO",
      zip: "80550",
      phone: "(970) 686-2380",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Windsor, approximately 10 miles east of Loveland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for east Loveland and Windsor residents. Smaller facility — call ahead for availability.",
      icon: "ri-mail-line",
    },
    {
      id: "lov-4",
      name: "Greeley Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "925 11th Ave",
      city: "Greeley",
      state: "CO",
      zip: "80631",
      phone: "(970) 352-2800",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Greeley, approximately 20 miles east of Loveland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for east Loveland and Weld County residents. Good parking. Larger facility with decent availability.",
      icon: "ri-mail-line",
    },
    {
      id: "lov-5",
      name: "Larimer County Clerk — Loveland",
      type: "County Clerk Passport Acceptance",
      address: "200 Peridot Ave",
      city: "Loveland",
      state: "CO",
      zip: "80537",
      phone: "(970) 619-4425",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Loveland, in the Larimer County Loveland Campus",
      website: "https://www.larimer.gov/",
      websiteLabel: "Larimer County Clerk",
      notes: "County clerk passport acceptance. Extended morning hours compared to post office. Convenient south Loveland location. DMV services also available at this location.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 1hr drive to Denver on I-25", fpc: "No — ship from Loveland" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Northern CO Travel", agency: "Full-day commitment for Denver drive", fpc: "Work done from home in Loveland" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Not Starting Early Enough from Northern Colorado",
      description: "Loveland residents are 60 miles from the Colorado Passport Agency. Routine processing takes 8–11 weeks. If you're planning international travel, start expedited service at least 4 weeks ahead rather than trying to schedule a Denver agency appointment.",
    },
    {
      icon: "ri-image-line",
      title: "Using Non-Compliant Passport Photos",
      description: "Photos from self-service kiosks at drug stores and big-box retailers are frequently rejected. Passport photos must be exactly 2×2 inches on a white background with no shadows — taken within 6 months.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities in Advance",
      description: "Loveland and Fort Collins post office appointments fill during peak summer travel season (June–August). Book your appointment at least 2–3 weeks ahead, especially if you need weekend or evening hours.",
    },
    {
      icon: "ri-snowflake-line",
      title: "Underestimating Winter Travel to Denver",
      description: "Many Loveland residents attempt to drive to Denver for a passport agency appointment. Winter storms on I-25, the I-25 gap construction, and the 1-hour drive each way make this impractical. Let our couriers handle it.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Visa Requirements for Sculpture Festival Travel",
      description: "Loveland's arts community frequently travels internationally for sculpture symposiums, gallery shows, and artist residencies. Many destinations require visas in addition to a passport. Check all entry requirements early.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Assuming FNL Has International Flights",
      description: "Northern Colorado Regional Airport (FNL) is a domestic-only general aviation airport. All international travel from Loveland requires driving to DEN or connecting through a major hub. Verify your full itinerary requirements.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Loveland or northern Colorado." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Loveland, Fort Collins, or Centerra." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for northern Colorado documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no I-25 drive to Denver required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Loveland address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Loveland, CO?", a: "Fast Passport Center offers emergency passport processing in Loveland, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 60-mile, 1-hour drive down I-25 to the Colorado Passport Agency in Aurora." },
    { q: "Does Loveland have its own passport agency?", a: "No — Loveland does not have a regional passport agency. The nearest is the Colorado Passport Agency (60 miles south via I-25). Fast Passport Center's courier service means Loveland residents never need to deal with I-25 traffic and the long drive to Denver." },
    { q: "Can I fly internationally from Northern Colorado Regional Airport (FNL)?", a: "FNL is a general aviation airport with no commercial passenger service. All international travel from Loveland requires connecting through Denver International Airport (DEN) — about 50 minutes south via I-25. Always verify your full itinerary requirements." },
    { q: "What if I live in Fort Collins, Windsor, or Berthoud?", a: "Absolutely. Fast Passport Center serves all of Larimer County and northern Colorado including Fort Collins, Windsor, Berthoud, Johnstown, Timnath, Severance, and Wellington. Our service works the same way everywhere — ship your documents and we handle the rest." },
    { q: "Can you help with passports for Loveland's arts community?", a: "Yes. Fast Passport Center has extensive experience with Loveland's arts community — from sculptors traveling to international symposiums to gallery owners attending European art fairs. We understand the unique travel patterns of artists and can coordinate expedited services to match exhibition schedules." },
    { q: "How much does an expedited passport cost in Loveland, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Loveland?", a: "Walgreens at Eisenhower and Lincoln (1400 Denver Ave) and the location on 29th St offer passport photo services. UPS Store in Centerra and CVS on 29th Street also provide photos. FedEx Office in Fort Collins is another option. Photos must be 2×2 inches on a white background." },
    { q: "Does Fast Passport Center serve Estes Park and the Big Thompson Canyon?", a: "Yes. Fast Passport Center serves all of Larimer County including Estes Park, Drake, and the Big Thompson Canyon communities. As the gateway to Rocky Mountain National Park, we understand the unique needs of mountain community residents and seasonal workers." },
  ],
  photoLocations: [
    { name: "Walgreens — Eisenhower Loveland", address: "1400 Denver Ave, Loveland, CO 80538", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — 29th St Loveland", address: "205 E 29th St, Loveland, CO 80538", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Centerra Loveland", address: "5971 Sky Pond Dr, Loveland, CO 80538", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
    { name: "FedEx Office — Fort Collins", address: "113 E Drake Rd, Fort Collins, CO 80525", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "DMV — Loveland (Larimer County)", address: "200 Peridot Ave, Loveland, CO 80537", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Loveland and southern Larimer County residents. REAL ID and driver's license renewals. Same complex as the County Clerk passport office.", featured: true },
    { name: "DMV — Fort Collins (Larimer County)", address: "200 W Oak St, Fort Collins, CO 80521", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for Fort Collins area residents. REAL ID processing available. Approximately 12 miles north of Loveland.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "55 miles from Loveland via I-25 south",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. About 50 minutes from Loveland in good traffic.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "FNL",
      name: "Northern Colorado Regional Airport",
      distance: "8 miles from Loveland via I-25",
      address: "4900 Earhart Rd, Loveland, CO 80538",
      note: "General aviation and regional airport serving Loveland and Fort Collins. Private jet and charter services available. No commercial passenger flights currently. Convenient for private aviation travelers.",
      flightUrl: "https://www.flynoco.com/",
      flightLabel: "FNL Airport Info",
      featured: false,
    },
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "120 miles from Loveland via I-25 south",
      address: "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916",
      note: "Alternative regional airport with domestic connections. About 2 hours south of Loveland.",
      flightUrl: "https://www.flycos.com/",
      flightLabel: "COS Flight Info",
      featured: false,
    },
  ],
};